var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var ADD_LMS_GROUPS_REQUEST = 'add_lms_groups_request';
export var ADD_LMS_GROUPS_FAIL = 'add_lms_groups_fail';
export var ADD_LMS_GROUPS_SUCCESS = 'add_lms_groups_success';
var initialState = {
    groups: [],
    isLoaded: false,
    isLoading: false
};
export function getLMSInfoReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ADD_LMS_GROUPS_REQUEST:
            return __assign(__assign({}, state), { isLoading: true });
        case ADD_LMS_GROUPS_FAIL:
            return __assign(__assign({}, state), { isLoading: false, isLoaded: true });
        case ADD_LMS_GROUPS_SUCCESS:
            return __assign(__assign({}, state), { groups: action.payload.groups, isLoaded: true, isLoading: false });
        default:
            return state;
    }
}
export function getLMSGroups(state) {
    return {
        groups: state.getLMSInfo.groups || [],
        isLoaded: state.getLMSInfo.isLoaded || false,
        isLoading: state.getLMSInfo.isLoading || false
    };
}
//# sourceMappingURL=getLMSInfo.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var ADD_LMS_GROUPS_REQUEST = 'add_lms_groups_request';
export var ADD_LMS_GROUPS_FAIL = 'add_lms_groups_fail';
export var ADD_LMS_GROUPS_SUCCESS = 'add_lms_groups_success';
var initialState = {
    groups: [],
    isLoaded: false,
    isLoading: false
};
export function getLMSInfoReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ADD_LMS_GROUPS_REQUEST:
            return __assign(__assign({}, state), { isLoading: true });
        case ADD_LMS_GROUPS_FAIL:
            return __assign(__assign({}, state), { isLoading: false, isLoaded: true });
        case ADD_LMS_GROUPS_SUCCESS:
            return __assign(__assign({}, state), { groups: action.payload.groups, isLoaded: true, isLoading: false });
        default:
            return state;
    }
}
export function getLMSGroups(state) {
    return {
        groups: state.getLMSInfo.groups || [],
        isLoaded: state.getLMSInfo.isLoaded || false,
        isLoading: state.getLMSInfo.isLoading || false
    };
}
//# sourceMappingURL=getLMSInfo.js.map